import { render, staticRenderFns } from "./SettingsReportView.vue?vue&type=template&id=63f2a6ce"
import script from "./SettingsReportView.ts?vue&type=script&lang=ts&external"
export * from "./SettingsReportView.ts?vue&type=script&lang=ts&external"
import style0 from "./SettingsReportView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports